import { AllProductsPage } from '../pages/AllProductsPage';

export function ResponsiveAllProductsPage() {
  return <AllProductsPage />;
}
